import Config from '../config/constants';
import axios, { AxiosResponse } from 'axios';

export const apiGetGrindHist = async (
  page: number, 
  limit: number, 
  branch_id: number | null, 
  machine_id: number | null, 
  createdFrom: string | null, 
  createdTo: string | null, 
  user_id: string | null,
  accessToken:string
): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/stats/grindhist`;

    try {
        const response = await axios.get(url, {
            params: {
                page,
                limit,
                branch_id,
                machine_id,
                createdFrom,
                createdTo,
                user_id,
            },headers: { access_token: accessToken }
        });
        
        console.log("res=" + response.data);

        return response;
    } catch (error) {
        console.error('Error fetching grind history:', error);
        throw error;
    }
};

/**
 * 전체 분쇄 이력 데이터를 가져오는 API (엑셀 다운로드용)
 * 페이지네이션 없이 모든 데이터를 반환
 */
export const apiGetAllGrindHist = async (
  branch_id: number | null, 
  machine_id: number | null, 
  createdFrom: string | null, 
  createdTo: string | null, 
  user_id: string | null,
  accessToken: string
): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/stats/grindhist`;

    try {
        const response = await axios.get(url, {
            params: {
                page: 1,
                limit: 999999, // 매우 큰 수로 설정하여 모든 데이터 가져오기
                branch_id,
                machine_id,
                createdFrom,
                createdTo,
                user_id,
            },
            headers: { access_token: accessToken }
        });
        
        console.log("전체 데이터 조회 완료:", response.data);

        return response;
    } catch (error) {
        console.error('Error fetching all grind history:', error);
        throw error;
    }
};

export const apiGetGrindPointHist = async (
    page: number, 
    limit: number, 
    branch_id: number | null, 
    machine_id: number | null, 
    createdFrom: string | null, 
    createdTo: string | null, 
    user_id: string | null,
    method: string | null,
    accessToken: string
  ): Promise<AxiosResponse> => {
      const url = `${Config.API_HOST}/api/admin/stats/pointhist`;
  
      try {
          const response = await axios.get(url, {
              params: {
                  page,
                  limit,
                  branch_id,
                  machine_id,
                  createdFrom,
                  createdTo,
                  user_id,
                  method,
              },headers: { access_token: accessToken }
          });
          
          console.log("res=" + response.data);
  
          return response;
      } catch (error) {
          console.error('Error fetching grind history:', error);
          throw error;
      }
  };
  